import type { ReactNode } from 'react';
import { WagmiConfig } from 'wagmi';

import { wagmiConfig } from '../lib';
import {
  MfaProvider,
  Web3AuthProvider,
  Web3ChainStatusProvider,
  Web3StateProvider,
} from './app-state-context';
import { WrappedApolloContext } from './app-state-context/apollo/apollo.provider';
import { CoinGeckoContextProvider } from './app-state-context/coingecko/coingecko.provider';
import { MarketplaceContextProvider } from './app-state-context/marketplace/marketplace.provider';
import { ModalStateContextProvider } from './app-state-context/modal-state.provider';
import { MoralisContextProvider } from './app-state-context/moralis/moralis.provider';
import { TradeStateContextProvider } from './app-state-context/trade/trade.provider';

interface Props {
  children: ReactNode;
}

export const Contexts = ({ children }: Props) => {
  return (
    <WagmiConfig config={wagmiConfig}>
      <Web3ChainStatusProvider>
        <Web3StateProvider>
          <Web3AuthProvider>
            <MfaProvider>
              <WrappedApolloContext>
                <MoralisContextProvider>
                  <CoinGeckoContextProvider>
                    <TradeStateContextProvider>
                      <MarketplaceContextProvider>
                        <ModalStateContextProvider>
                          {children}
                        </ModalStateContextProvider>
                      </MarketplaceContextProvider>
                    </TradeStateContextProvider>
                  </CoinGeckoContextProvider>
                </MoralisContextProvider>
              </WrappedApolloContext>
            </MfaProvider>
          </Web3AuthProvider>
        </Web3StateProvider>
      </Web3ChainStatusProvider>
    </WagmiConfig>
  );
};
